import * as React from "react";
import { ReadingLevelSearchForm } from "../../ReadingLevelSearchForm";
import { AdvancedSearchEvent } from "../../BooleanSearchForm";
import { LoaderFunctionArgs, redirect, useNavigate } from "react-router";
import { LocationConfigurationHolder } from "../../LocationConfiguration";
import { isReadingLevelSearch } from "./advanced/AdvancedSearchTerm";
import { useSearchParams } from "react-router-dom";
import { readingLevelSearchAdapter } from "./advanced/reading-levels/readingLevelSearchAdapter";

export async function readingLevelLoader({ request }: LoaderFunctionArgs) {
  console.log("readingLevelLoader executing");

  const { pacSettings } =
    await LocationConfigurationHolder.fetchLocationConfiguration();

  if (!pacSettings.acceleratedReaderEnabled && !pacSettings.lexileEnabled) {
    return redirect("/advanced-search/boolean");
  }

  const url = new URL(request.url);
  const params = new URLSearchParams(url.searchParams);
  const term = params.get("term");
  const validTerm = readingLevelSearchAdapter.getTerm(params);
  if (term && !validTerm) {
    params.delete("term");
    return redirect(`/advanced-search/reading-levels?${params.toString()}`);
  } else if (validTerm) {
    const { readingLevelFilters, searchTokens } = validTerm;
    const {
      lexileStart,
      lexileEnd,
      bookLevelStart,
      bookLevelEnd,
      interestLevel,
    } = readingLevelFilters;
    const searchTerm = searchTokens[0].searchString;
    const hasNumber = [
      lexileStart,
      lexileEnd,
      bookLevelStart,
      bookLevelEnd,
    ].some((v) => typeof v === "number" && Number.isFinite(v));
    const hasString = [interestLevel, searchTerm].some(
      (v) => typeof v === "string" && v.trim().length > 0
    );
    if (!hasNumber && !hasString) {
      // term is empty, strip it and redirect
      params.delete("term");
      return redirect(`/advanced-search/reading-levels?${params.toString()}`);
    }
  }
  return null;
}

export const ReadingLevelSearchPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handleAdvancedSearchEvent = (event: AdvancedSearchEvent) => {
    const { searchString, branchFilters } = event;
    if (!isReadingLevelSearch(searchString)) return;

    const params = new URLSearchParams(searchParams);
    if (Array.isArray(branchFilters)) {
      params.set("branchFilters", JSON.stringify(branchFilters));
    }
    navigate(
      `/advanced-search/reading-levels/results?${readingLevelSearchAdapter
        .setTerm(params, searchString)
        .toString()}`
    );
  };

  return (
    <ReadingLevelSearchForm
      onClickSearch={handleAdvancedSearchEvent}
    ></ReadingLevelSearchForm>
  );
};
